import { useEffect, useState } from 'react'
import { AccountIdentifier } from '@dfinity/ledger-icp'
import { shortAddress } from '../utils/shortAddress'
import { TransactionActivity } from '../interfaces/transactionActivity'
import { useContacts, useWalletProperties } from '../state'
import { TransactionType } from '../interfaces/common'
import { getPrincipals } from '../handlers/walletActions/wallet'
import { TransactionKind } from '../clients/LedgerScannerClient'

export const hasOtherParty = (tx: TransactionActivity) =>
  tx.kind === TransactionKind.Approve || tx.kind === TransactionKind.Transfer

export default ({ transaction, long }: { transaction: TransactionActivity; long?: boolean }) => {
  const { getContactByAddress } = useContacts()
  const { walletNames } = useWalletProperties()

  const [otherParty, setOtherParty] = useState('')

  let address: string
  if (!hasOtherParty(transaction)) {
    address = ''
  } else if (transaction.type === TransactionType.Send) {
    address = transaction.receiverAddress
  } else {
    address = transaction.senderAddress
  }

  useEffect(() => {
    const findOtherParty = async () => {
      if (!address) return

      const contact = getContactByAddress(address)

      if (contact) {
        setOtherParty(contact.name)
      } else {
        const principals = await getPrincipals()
        const principal = principals.find((p) => {
          const accountId = AccountIdentifier.fromPrincipal({ principal: p })

          return p.toString() === address || accountId.toHex() === address
        })

        if (principal) {
          setOtherParty(walletNames[principal.toString()] || 'account1')
        }
      }
    }

    findOtherParty()
  }, [address])

  const leftSize = long ? 12 : undefined

  return {
    otherParty: otherParty || shortAddress(address, { leftSize }),
    isRecognized: !!otherParty,
    fullAddress: address,
  }
}
